import React from 'react'

const PlayerLoader = ({ isBuffering }) => {
    return (
        <div
            style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            visibility: isBuffering ? 'visible' : 'hidden',
            zIndex: 2,
            }}
        >
            <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default PlayerLoader